var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediumRoundIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6048_52447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0731 17.6426H36.9302C40.4806 17.6426 43.3588 20.5208 43.3588 24.0711V36.9283C43.3588 40.4786 40.4806 43.3568 36.9302 43.3568H24.0731C20.5227 43.3568 17.6445 40.4786 17.6445 36.9283V24.0711C17.6445 20.5205 20.5225 17.6426 24.0731 17.6426Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5001 0.5C5.50002 0.5 0.5 5.50002 0.5 15.5001V45.5002C0.5 55.5002 5.50002 60.5002 15.5001 60.5002H45.5002C55.5002 60.5002 60.5002 55.5002 60.5002 45.5002V15.5001C60.5 5.50002 55.5 0.5 45.4999 0.5H15.5001ZM9.0715 16.5714C9.0715 11.5714 11.5714 9.0715 16.5714 9.0715H44.4286C49.4286 9.0715 51.9285 11.5714 51.9285 16.5714V44.4286C51.9285 49.4286 49.4286 51.9285 44.4286 51.9285H16.5714C11.5714 51.9285 9.0715 49.4286 9.0715 44.4286V16.5714Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6048_52447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumRoundIcon);
export default __webpack_public_path__ + "static/media/medium-round-icon.09d8f07519bee10a0be3c217e237581f.svg";
export { ForwardRef as ReactComponent };